import ProjectComponent from './project_component'
import React, { forwardRef } from 'react'
import './project.scss'

var projects_data = [
  {
    title: 'Renewables Plant Project',
    title_sub_heading: 'Optimization, Financial Optimization',
    imagePath: process.env.PUBLIC_URL + '/images/energyProject.webp',
    description:
      'Made at KPMG under 3 Partners for a cross-domain project that was demonstrated live to the clients. Worked with National Lead of Clean Energy Partner Ms. Anvesha Thakkar'
  },
  {
    title: 'GAIL Compressor Analysis',
    title_sub_heading: 'Data Analysis, Visualization',
    imagePath: process.env.PUBLIC_URL + '/images/gail.webp',
    description:
      'For KPMG, analysis of compressors used at GAIL (Gas AUthority of India Ltd.) was done in order to find innefficiencies in the way they get handled.'
  },
  {
    title: 'Realtime Parking System',
    title_sub_heading: 'Computer Vision, App Development',
    imagePath: process.env.PUBLIC_URL + '/images/parking.webp',
    description:
      'Problem posted by Ministry of Housing & Urban Affairs, the team created ML models and an application to utilize available parking space to max extent.'
  }
]
const Projects = forwardRef((props, ref) => {
  return (
    <div ref={ref} className='project_section'>
      <h1>Projects</h1>
      {projects_data.map((element, index) => (
        <ProjectComponent
          key={index}
          imagePath={element.imagePath}
          title={element.title}
          title_sub_heading={element.title_sub_heading}
          description={element.description}
          link={element.link}
          rank={element.rank}
          buttonText={element.buttonText}
        />
      ))}
    </div>
  )
})

export default Projects
